/*
 * global Actions
 *
 * @version 1.0.0
 * @author Pietro Bertuccelli
 * @since 10-Oct-2024
 */

import { createRequestTypes, createAction, MakeRequest } from './index'

export const actionTypes = {
  DO_PHONE_PREFIXES: '@@global/phone_prefixes',
  DO_SAVE_FIREBASE_TOKEN: '@@global/save_firebase_token',
  DO_SET_OUTCOME_ANALYTICS: '@@global/set_outcome_analytics',
  DO_CHECK_DEEP_LINKING: '@@global/check_deep_linking',
  DO_SAVE_ACTION: '@@global/save_action',
  DO_GET_MIN_VERSION: '@@global/get_min_version',
  DO_SET_SELECTED_TAB: '@@global/set_selected_tab',
  DO_SET_TRANSACTION_FILTER_SEARCH_NOTE_LIST: '@@global/set_transaction_filter_search_note_list',
  DO_SET_HOME_LAST_TRANSACTION_DETAILS: '@@global/set_home_last_transaction_details',
  DO_SET_PROMO_END_DATE: '@@global/set_promo_end_date',
  DO_SET_FREE_MONTHS: '@@global/set_free_months',
  DO_CONSUME_TOKEN_NPG: '@@global/consume_token_npg',
  DO_SET_PAGOPA_BILLING_CONFIRMED: '@@global/set_pagopa_billing_confirmed',
  DO_SET_PCI_PROTECTION_LEVEL: '@@global/set_pci_protection_level',
  DO_GET_AML_SURVEY_INFO: '@@global/get_aml_survey_info',
  DO_EVENTS: '@@global/events',

  // @generator action:type
  ...createRequestTypes('@@global', 'PHONE_PREFIXES'),
  ...createRequestTypes('@@global', 'SET_OUTCOME_ANALYTICS'),
  ...createRequestTypes('@@global', 'CHECK_DEEP_LINKING'),
  ...createRequestTypes('@@global', 'GET_MIN_VERSION'),
  ...createRequestTypes('@@global', 'SAVE_FIREBASE_TOKEN'),
  ...createRequestTypes('@@global', 'CONSUME_TOKEN_NPG'),
  ...createRequestTypes('@@global', 'GET_AML_SURVEY_INFO'),
  ...createRequestTypes('@@global', 'EVENTS')
  // @generator action:type:request
}

// ------------------------------------
// Actions
// ------------------------------------

/** @action request
 * * Insert a description
 * @name phonePrefixes
 * @return {object} - The action object
 */
export const phonePrefixes = new MakeRequest('global', 'phone_prefixes')
/** @action request
 * * Insert a description
 * @name setOutcomeAnalytics
 * @return {object} - The action object
 */
export const setOutcomeAnalytics = new MakeRequest('global', 'set_outcome_analytics')
/** @action request
 * * Insert a description
 * @name checkDeepLinking
 * @return {object} - The action object
 */
export const checkDeepLinking = new MakeRequest('global', 'check_deep_linking')
/** @action request
 * * Insert a description
 * @name getMinAppVersion
 * @return {object} - The action object
 */
export const getMinAppVersion = new MakeRequest('global', 'get_min_version')
/** @action request
 * * Insert a description
 * @name consumeTokenNpg
 * @return {object} - The action object
 */
export const consumeTokenNpg = new MakeRequest('global', 'consume_token_npg')
/** @action request
 * @name saveFirebaseToken
 * @return {object} - The action object
 */
export const saveFirebaseToken = new MakeRequest('global', 'save_firebase_token')
/** @action request
 * * Action to get the AML survey snapshot used outside the AML route flow
 * @name getAmlSurveyInfo
 * @return {object} - The action object
 */
export const getAmlSurveyInfo = new MakeRequest('global', 'get_aml_survey_info')
/** @action request
 * * Insert a description
 * @name events
 * @return {object} - The action object
 */
export const events = new MakeRequest('global', 'events')

// @generator action:request

/** @action
 * * Insert a description
 * @name PhonePrefixes
 * @return {object} - The payload object
 */
export const doPhonePrefixes = payload => createAction(actionTypes.DO_PHONE_PREFIXES, { payload })
/** @action
 * * Insert a description
 * @name ConsumeTokenNpg
 * @return {object} - The payload object
 */
export const doConsumeTokenNpg = payload => createAction(actionTypes.DO_CONSUME_TOKEN_NPG, { payload })
/** @action
 * * Insert a description
 * @name SetOutcomeAnalytics
 * @return {object} - The payload object
 */
export const doSetOutcomeAnalytics = ({ response, description, statusCode = 1, customResponseMessage }) => createAction(actionTypes.DO_SET_OUTCOME_ANALYTICS, { response, description, statusCode, customResponseMessage })

/** @action
 * * Insert a description
 * @name CheckDeepLinking
 * @return {object} - The payload object
 */
export const doCheckDeepLinking = payload => createAction(actionTypes.DO_CHECK_DEEP_LINKING, { payload })

/** @action
 * * Insert a description
 * @name SaveAction
 * @return {object} - The payload object
 */
export const doSaveAction = payload => createAction(actionTypes.DO_SAVE_ACTION, { payload })
/** @action
 * * Insert a description
 * @name GetMinAppVersion
 * @return {object} - The payload object
 */
export const doGetMinAppVersion = payload => createAction(actionTypes.DO_GET_MIN_VERSION, { payload })
/** @action
 * * Insert a description
 * @name SaveFirebaseToken
 * @return {object} - The payload object
 */
export const doSaveFirebaseToken = payload => createAction(actionTypes.DO_SAVE_FIREBASE_TOKEN, { payload })

/** @action
 * * Insert a description
 * @name SetSelectedTab
 * @return {object} - The payload object
 */
export const doSetSelectedTab = payload => createAction(actionTypes.DO_SET_SELECTED_TAB, { payload })
/** @action
 * * Insert a description
 * @name doSetTransactionFilterSearchNoteList
 * @return {object} - The payload object
 */
export const doSetTransactionFilterSearchNoteList = payload => createAction(actionTypes.DO_SET_TRANSACTION_FILTER_SEARCH_NOTE_LIST, { payload })
/** @action
 * * Insert a description
 * @name doSetHomeLastTransactionDetails
 * @return {object} - The payload object
 */
export const doSetHomeLastTransactionDetails = payload => createAction(actionTypes.DO_SET_HOME_LAST_TRANSACTION_DETAILS, { payload })

/** @action
 * * Set promo end date
 * @name doSetPromoEndDate
 * @return {object} - The payload object
 */
export const doSetPromoEndDate = payload => createAction(actionTypes.DO_SET_PROMO_END_DATE, { payload })

/** @action
 * * Set free months
 * @name doSetFreeMonths
 * @return {object} - The payload object
 */
export const doSetFreeMonths = payload => createAction(actionTypes.DO_SET_FREE_MONTHS, { payload })

/** @action
 * * Set PCI protection level
 * @name doSetPciProtectionLevel
 * @return {object} - The payload object
*/
export const doSetPciProtectionLevel = payload => createAction(actionTypes.DO_SET_PCI_PROTECTION_LEVEL, { payload })

/** @action
 * * Get the AML survey snapshot used outside the AML route flow
 * @name doGetAmlSurveyInfo
 * @return {object} - The payload object
 */
export const doGetAmlSurveyInfo = payload => createAction(actionTypes.DO_GET_AML_SURVEY_INFO, { payload })

/** @action
 * * Insert a description
 * @name doEvents
 * @return {object} - The payload object
 */
export const doEvents = payload => createAction(actionTypes.DO_EVENTS, { payload })

// @generator action
